import { Box, Button, Icon, Table, Text } from '@factorialco/deprecated-design-system'

import TextField from 'modules/core/components/TextField'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

import {
  calculatePhaseProfit,
  calculatePhaseTotalCost,
  calculatePhaseTotalHours,
  calculatePhaseTotalToBill,
} from 'modules/finance/components/Quotes/QuotePhasesTable/_Body/lib/calculations'
import type { QuotePhase } from 'modules/finance/components/Quotes/QuotePhasesTable/types'

interface PhaseRowProps {
  phase: QuotePhase
  currency: string
  onToggleExpand: () => void
  onDelete: () => void
  onUpdate: (updates: Partial<QuotePhase>) => void
}

const PhaseRow = ({ phase, currency, onToggleExpand, onDelete, onUpdate }: PhaseRowProps) => {
  const {
    access: { locale },
  } = useCurrentSession()

  const totalHours = calculatePhaseTotalHours(phase)
  const totalCost = calculatePhaseTotalCost(phase)
  const totalToBill = calculatePhaseTotalToBill(phase)
  const profit = calculatePhaseProfit(phase)

  return (
    <Table.Row>
      <Table.Cell colSpan={2}>
        <Box flexDirection="row" alignItems="center" gap="s8" width="s300">
          <Box onClick={onToggleExpand}>
            <Icon.Small icon={phase.isExpanded ? 'chevron-down' : 'chevron-right'} />
          </Box>
          <TextField
            type="text"
            value={phase.name}
            onChange={(value) => onUpdate({ name: value })}
          />
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Text size="300" color="grey1000" weight="semibold">
          {i18n.t('common.decimal_to_time.hours.basic.hour_amount', {
            total: totalHours,
          })}
        </Text>
      </Table.Cell>
      <Table.Cell colSpan={2} />
      <Table.Cell colSpan={2} />
      <Table.Cell colSpan={2}>
        <Box textAlign="right">
          <Text size="300" color="grey1000" weight="semibold">
            {`${profit.toFixed(2)}\u00A0%`}
          </Text>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box textAlign="right">
          <Text size="300" color="grey1000" weight="semibold">
            {MoneyWithCurrency({
              optionalDecimals: true,
              amount: totalCost,
              currency,
              locale,
            })}
          </Text>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box textAlign="right">
          <Text size="300" color="grey1000" weight="semibold">
            {MoneyWithCurrency({
              optionalDecimals: true,
              amount: totalToBill,
              currency,
              locale,
            })}
          </Text>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={1} width={80}>
        <Button type="secondary" iconName="delete" onClick={onDelete} />
      </Table.Cell>
    </Table.Row>
  )
}

export default PhaseRow
